// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".md-map[data-v-5b7401ba]{margin:.4em 0;width:100%;max-width:36rem}.md-map.is-wide[data-v-5b7401ba]{max-width:none}.md-map-canvas[data-v-5b7401ba]{height:320px;border-radius:6px;overflow:hidden}.md-map-error[data-v-5b7401ba]{display:flex;align-items:center;gap:.4em;padding:.6em .8em;border:1px solid #f1c40f;background:#fffbea;border-radius:6px;color:#92720a;font-size:.85rem}", ""]);
// Exports
module.exports = exports;
